// extracted by mini-css-extract-plugin
module.exports = {"leftSideMenu":"LeftSideMenu_leftSideMenu__2s7aB"};